document.addEventListener('DOMContentLoaded', function () {
  const swiperElement = document.querySelector('.product-media-swiper');

  function initSwiper() {
    // Only initialize swiper on mobile (max-width: 989px)
    if (window.innerWidth <= 989 && swiperElement && typeof Swiper !== 'undefined') {
      if (!swiperElement.swiper) {
        new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 6,
          loop: false,
          centeredSlides: false,
          allowTouchMove: true,
          pagination: {
            el: '.product-media-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.product-media-button-next',
            prevEl: '.product-media-button-prev',
          },
        });
      }
    } else if (window.innerWidth > 989 && swiperElement && swiperElement.swiper) {
      // Destroy swiper on desktop
      swiperElement.swiper.destroy(true, true);
    }
  }

  initSwiper();

  // Reinitialize on resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSwiper();
    }, 250);
  });
});
